export class PersistenceSerializationError extends Error {
  constructor(message, options) {
    super(message, options);
    this.name = 'PersistenceSerializationError';
  }
}

export class PersistenceWriteError extends Error {
  constructor(message, options) {
    super(message, options);
    this.name = 'PersistenceWriteError';
  }
}

export class PersistenceRemoveError extends Error {
  constructor(message, options) {
    super(message, options);
    this.name = 'PersistenceRemoveError';
  }
}
